export const ageMethod = "age nearest";
export const gateway = "https://qat-guild-api.link-nonprod.wawanesalife.com";
export const assets = "https://qat-assets.link-nonprod.wawanesalife.com/brokers/guild";
export const googleApiKey = "AIzaSyD8GAXLH7FxUmF13tfHgXVAU6fWk66UH3k";
export const appToken = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJzdWIiOiJndWlsZCIsIm5hbWUiOiJndWlsZCIsImlhdCI6MTc4MDU4MjAxOCwiZXhwIjoxOTM4MzcwMDE4fQ.LfyYWqQGT2ZpGVD847o3D7heUwmUlsSox7HYCU3zT_w";
export const brokerConfig = {
	enabled: "yes",
	"split": '0.6'
};
export const brokerBranding = {
	"qat-guild-shopper.link-nonprod.wawanesalife.com": {
		a: {
			approve_company: "Link Platform",
			approve_user: "link_guild",
			brands: [
				"qat-guild-shopper.link-nonprod.wawanesalife.com",
			],
			broker: "guild",
			broker_formatted_name: "Guild Insurance Group",
			email: "info@guild.ca",
			environment: "qat",
			environment_id: "qat",
			g4: "G-14ZL6551EP",
			layout: "modern",
			logoPosition: "menu",
			menuPhone: "button",
			phone: "1-866-277-4949",
			privacyLink: "https://www.guild.ca/our-privacy-policy/",
			video_link: "oyQBe3TRMPw",
			website: "https://guild.ca/",
			scope: "guild#branding#qat-guild-shopper.link-nonprod.wawanesalife.com#a",
			ab: "a",
			logo: "a.png",
			brand_name: "qat-guild-shopper.link-nonprod.wawanesalife.com",
		},
		b: {
			approve_company: "Link Platform",
			approve_user: "link_guild",
			brands: [
				"qat-guild-shopper.link-nonprod.wawanesalife.com",
			],
			broker: "guild",
			broker_formatted_name: "Guild Insurance Group",
			email: "info@guild.ca",
			environment: "qat",
			environment_id: "qat",
			g4: "G-14ZL6551EP",
			layout: "modern",
			logoPosition: "menu",
			menuPhone: "button",
			phone: "1-866-277-4949",
			privacyLink: "https://www.guild.ca/our-privacy-policy/",
			video_link: "oyQBe3TRMPw",
			website: "https://guild.ca/",
			scope: "guild#branding#qat-guild-shopper.link-nonprod.wawanesalife.com#b",
			ab: "b",
			logo: "b.png",
			brand_name: "qat-guild-shopper.link-nonprod.wawanesalife.com",
		},
	},
};

//updated on Thu Jun 04 2026 14:06:58 GMT+0000 (Coordinated Universal Time)
